const boxSizesKeysAndLabels = [ // the label is for withTranslation('checkprice')
  ['document', 'sizes.a3a4'],
  ['ก', 'sizes.a'],
  ['ข', 'sizes.b'],
  ['ค', 'sizes.c'],
  ['ง', 'sizes.d'],
  ['จ', 'sizes.e'],
  ['ฉ', 'sizes.f'],
  ['box0', 'sizes.box0'],
  ['box1', 'sizes.box1'],
  ['box2', 'sizes.box2'],
  ['box3', 'sizes.box3'],
  ['box4', 'sizes.box4'],
  ['box5', 'sizes.box5'],
  ['box6', 'sizes.box6'],
]

const getWlhByBoxSize = (boxSizeKey) => {
  const toObject = (width,length,height) => ({width:width,length:length,height:height})
  switch (boxSizeKey) {
    case 'document': return toObject(10,10,10)
    case 'ก': return toObject(14,20,6)
    case 'ข': return toObject(17,25,9)
    case 'ค': return toObject(20,30,11)
    case 'ง': return toObject(22,35,14)
    case 'จ': return toObject(24,40,17)
    case 'ฉ': return toObject(30,45,20)
    case 'box0': return toObject(11,17,6)
    case 'box1': return toObject(30,100,30)
    case 'box2': return toObject(31,36,13)
    case 'box3': return toObject(31,36,26)
    case 'box4': return toObject(55,100,55)
    case 'box5': return toObject(40,45,35)
    case 'box6': return toObject(45,55,40)
    case 'blankWlh': return 'blankWlh'
    case '111': return toObject(1,1,1)
    case '222': return toObject(2,2,2)
    default: return 'blankWlh'
  }
}

const estimateWeight = (obj) => {
  if (obj === 'blankWlh') return ''
  const { width, length, height } = obj
  return (parseInt(width) * parseInt(length) * parseInt(height)) / 5
}

const getBoxSizeByWlh = (wlh) => {
  const boxesList = [
    'document',
    'box0',
    'ก',
    'ข',
    'ค',
    'ง',
    'จ',
    'ฉ',
    'box1',
    'box2',
    'box3',
    'box5',
    'box6',
    'box4',
  ]
  const preferredBox = boxesList.find(boxSize => {
    const boxSizeObject = getWlhByBoxSize(boxSize)
    return (
      parseInt(boxSizeObject.width) >= parseInt(wlh.width) &&
      parseInt(boxSizeObject.height) >= parseInt(wlh.height) &&
      parseInt(boxSizeObject.length) >= parseInt(wlh.length)
    )
  })
  return preferredBox ? preferredBox : false
}

export {
  boxSizesKeysAndLabels,
  getWlhByBoxSize,
  estimateWeight,
  getBoxSizeByWlh,
}